import { Link } from 'react-router-dom';

interface HoitoLogoProps {
  className?: string;
  showText?: boolean;
  href?: string;
  /** Use 'light' on dark backgrounds (nav/hero) for white icon and text */
  variant?: 'default' | 'light';
}

export default function HoitoLogo({ className = '', showText = true, href = '/', variant = 'default' }: HoitoLogoProps) {
  const isLight = variant === 'light';
  const content = (
    <>
      <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center ${isLight ? 'bg-white text-slate-900' : 'bg-brand-900 text-white'}`}>
        <span className="font-bold text-sm">H</span>
      </div>
      {showText && (
        <span className={`ml-2 text-lg font-semibold tracking-tight ${isLight ? 'text-white' : 'text-brand-900'}`}>
          Hoito
        </span>
      )}
    </>
  );

  const classes = `inline-flex items-center ${className}`;

  if (href) {
    return (
      <Link to={href} className={classes}>
        {content}
      </Link>
    );
  }

  return <div className={classes}>{content}</div>;
}
